const UnorderedList = ({ children, className }) =>{
    return(
        <ul className={className}>
            { children }
        </ul>
    )
}
export default UnorderedList